export const checkDisallowRequestUpdate = (store, type) => {
    switch (store) {
        case 'gkxp089':
            return true
        case '1736mjc':
            return ['CUSTOM_ORN_0103MTM', '2L_KEY_0102MT', '1W_ORN_0103MT', 'L1W_ORN_0103MT'].includes(type)
        default:
            return false
    }
}